import React, { useReducer, useState } from "react";
import "./styles.css";

import box from "../../assets/box.png";
import boxLid from "../../assets/box-lid.png";
import kuku from "../../assets/japan.png";
// import ConfettiGenerator from "./CanvasConfetti";
import Confetti from "./confetti/Confetti";
import { useNavigate } from "react-router-dom";

const init_state = {
  move: "move",
  jump: "",
  rotated: "",
  rotating: ""
};
export default function GiftBoxAnimation() {
  const [state, setState] = useReducer(
    (state, new_state) => ({
      ...state,
      ...new_state
    }),
    init_state
  );

  let navigate = useNavigate();
  const routeChange = () => {
    let path = `gift`;
    navigate(path);
  }

  const [showConfusedMessage, setShowConfusedMessage] = useState(false);

  const { move, rotating, rotated, jump } = state;

  function animate() {

    let isDone = rotated === "rotated" ? true : false;

    if (!isDone) {
      setTimeout(function () { setShowConfusedMessage(true); }, 3000);
      setState({ rotating: "rotating" });
      setTimeout(() => {
        setState({ jump: "jump" });
      }, 300);
      setTimeout(() => {
        setState({ rotated: "rotated" });
      }, 1000);
    } else {
      setShowConfusedMessage(false)
      setState(init_state);
    }
    let moving = move === "move" ? "" : "move";
    setState({ move: moving });
  }

  return (
    <div className="App">
      <Confetti open={jump === "jump"} />
      <div className="img-container">
        <img className={`kuku ${jump}`} src={kuku} alt="kuku" />
        <button className="box" onClick={() => animate()}>
          <img src={box} alt="box" />
        </button>
        <img
          className={`lid ${move} ${rotating} ${rotated}`}
          src={boxLid}
          alt="box-lid"
        />
      </div>
      {showConfusedMessage && <h2 style={{color: '#378b29', cursor: "pointer"}} onClick={routeChange}>Verwirrt??? Klicke um mehr herauszufinden</h2>}
    </div>
  );
}
